$('.sim-thumb').on('click', function() {
  $('#main-product-image').attr('src', $(this).data('image'));
})